import React from "react";
import { useMarket } from "../contexts/MarketContext";
import DashboardLayout from "../shared/DashboardLayout";

const GlobalDashboard = () => {
  const { isGlobalView } = useMarket();

  if (!isGlobalView) {
    return null;
  }
  
  return (
    <DashboardLayout 
      mode="global"
      marketCode={null}
      marketName="Global Overview"
      accountId={null}
      onBackClick={null}
    />
  );
};

export default GlobalDashboard;